/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CompositeUniqueConstraint } from "./CompositeUniqueConstraint";
import { ExternalSheetConstraint } from "./ExternalSheetConstraint";
export const SheetConstraint = core.serialization
    .union("type", {
    unique: CompositeUniqueConstraint,
    external: ExternalSheetConstraint,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
